import { isDataplatform } from '@/shared/Config'

const components = {
  ActionEditor: () => import('@/dpe/components/Actions/ActionEditor'),
  ActionsRepositories: () => import('@/dpe/components/Actions/ActionsRepositories'),
  Console: () => import('@/dpe/components/Console'),
  DpeEditor: () => import('@/dpe/components/DpeEditor'),
  EnvironmentEditor: () => import('@/dpe/components/Environments/EnvironmentEditor'),
  Environments: () => import('@/dpe/components/Environments/Environments'),
  JobDetails: () => import('@/dpe/components/Jobs/JobDetails'),
  Jobs: () => import('@/dpe/components/Jobs/Jobs'),
  NotebookEditor: () => import('@/dpe/components/Notebooks/NotebookEditor'),
  Notebooks: () => import('@/dpe/components/Notebooks/Notebooks'),
  Overview: () => import('@/dpe/components/Overview'),
  Settings: () => import('@/dpe/components/Settings/Settings'),
  SparkHistory: () => import('@/dpe/components/SparkHistory/SparkHistory'),
  WorkflowAdvancedEditor: () => import('@/dpe/components/Workflows/WorkflowAdvancedEditor'),
  WorkflowEditor: () => import('@/dpe/components/Workflows/WorkflowEditor'),
  Workflows: () => import('@/dpe/components/Workflows/Workflows'),
  RouterRedirectDataplantId: () => import('@/shared/RouterRedirectDataplantId')
}

const routes = [
  {
    path: '/',
    name: 'DPE',
    component: components.RouterRedirectDataplantId,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:dataplantId/',
    name: 'DPE - Overview',
    display_name: 'searchbar.items.dpe.overview.display_name',
    description: 'searchbar.items.dpe.overview.description',
    searchable: true,
    component: components.Overview,
    meta: {
      analytics: { category: 'dashboard' },
      ready: ['dpe_actions']
    }
  },
  {
    path: '/:dataplantId/actions',
    name: 'DPE - Actions',
    display_name: 'searchbar.items.dpe.actions.display_name',
    description: 'searchbar.items.dpe.actions.description',
    searchable: true,
    component: components.ActionsRepositories,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Actions - ${parent(route, false)}`,
      ready: ['dpe_repositories', 'dpe_actions']
    }
  },
  {
    path: '/:dataplantId/action',
    name: 'DPE - New Action',
    component: components.ActionEditor,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Action - ${parent(route, false)}`,
      ready: ['dpe_repositories', 'dpe_actions', 'dpe_environments', 'dwh_metas', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/action/:id',
    name: 'DPE - Edit Action',
    component: components.ActionEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Action - ${parent(route, false)}`,
      ready: ['dpe_repositories', 'dpe_actions', 'dpe_environments', 'dwh_metas', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/action/:id/advanced',
    name: 'DPE - Edit Action Advanced',
    component: components.DpeEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Action - ${parent(route, false)}`,
      advanced: true,
      ready: ['dpe_repositories', 'dpe_actions', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/actions/advanced',
    name: 'DPE - Actions Advanced',
    component: components.DpeEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Actions - ${parent(route, false)}`,
      advanced: true,
      ready: ['dpe_repositories', 'dpe_actions', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/environments',
    name: 'DPE - Environments',
    display_name: 'searchbar.items.dpe.environments.display_name',
    description: 'searchbar.items.dpe.environments.description',
    searchable: true,
    component: components.Environments,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Environments - ${parent(route)}`,
      ready: ['dpe_environments']
    }
  },
  {
    path: '/:dataplantId/environment',
    name: 'DPE - New Environements',
    component: components.EnvironmentEditor,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Environment - ${parent(route)}`,
      ready: ['dpe_environments', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/environment/:id',
    name: 'DPE - Edit Environements',
    component: components.EnvironmentEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Environment - ${parent(route)}`,
      ready: ['dpe_environments', 'dwh_metas', 'iam_service_accounts']
    }
  },
  // It is no longer used
  // {
  //   path: '/:dataplantId/environments/advanced',
  //   name: 'DPE - Environements Advanced',
  //   component: EnvironmentAdvancedEditor,
  //   meta: {
  //     title: (route, parent) => `Environments - ${parent(route)}`,
  //     advanced: true,
  //     ready: ['dpe_environments', 'iam_service_accounts']
  //   }
  // },
  // {
  //   path: '/:dataplantId/environment/:id/advanced',
  //   name: 'DPE - Edit Environment Advanced',
  //   component: EnvironmentAdvancedEditor,
  //   meta: {
  //     title: (route, parent) => `Environment - ${parent(route)}`,
  //     advanced: true,
  //     ready: ['dpe_environments', 'iam_service_accounts']
  //   }
  // },
  {
    path: '/:dataplantId/workflows',
    name: 'DPE - Workflows',
    display_name: 'searchbar.items.dpe.workflows.display_name',
    description: 'searchbar.items.dpe.workflows.description',
    searchable: true,
    component: components.Workflows,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Workflows - ${parent(route, false)}`,
      ready: ['dpe_workflows']
    }
  },
  {
    path: '/:dataplantId/workflow',
    name: 'DPE - New Workflow',
    component: components.WorkflowEditor,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Workflow - ${parent(route, false)}`,
      ready: ['dpe_workflows', 'dpe_environments', 'dpe_actions', 'dpe_events', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/workflow/:id',
    name: 'DPE - Edit Workflow',
    component: components.WorkflowEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Workflow - ${parent(route, false)}`,
      ready: ['dpe_workflows', 'dpe_environments', 'dpe_actions', 'dpe_events', 'dwh_metas', 'dpe_jobs', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/workflows/advanced',
    name: 'DPE - Workflows Advanced',
    component: components.WorkflowAdvancedEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Workflows - ${parent(route, false)}`,
      advanced: true,
      ready: ['dpe_workflows', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/workflow/:id/advanced',
    name: 'DPE - Edit Workflow Advanced',
    component: components.WorkflowAdvancedEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Workflow - ${parent(route, false)}`,
      advanced: true,
      ready: ['dpe_workflows', 'iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/jobs',
    name: 'DPE - Jobs',
    display_name: 'searchbar.items.dpe.jobs.display_name',
    description: 'searchbar.items.dpe.jobs.description',
    component: components.Jobs,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Jobs - ${parent(route)}`,
      ready: ['dpe_jobs']
    }
  },
  {
    path: '/:dataplantId/spark-history',
    name: 'DPE - Spark History',
    display_name: 'searchbar.items.dpe.spark_history.display_name',
    description: 'searchbar.items.dpe.spark_history.description',
    searchable: true,
    component: components.SparkHistory,
    // DataPlatform-only feature: redirect to the overview on MRI
    beforeEnter: (to, from, next) => {
      isDataplatform() ? next() : next(`/${to.params.dataplantId}/`)
    },
    meta: {
      analytics: { category: 'exploration' },
      // No ready-gate: render now, job/task names fill in reactively as the preload lands
      title: (route, parent) => `Spark History - ${parent(route)}`
    }
  },
  {
    path: '/:dataplantId/settings',
    name: 'DPE - Settings',
    display_name: 'searchbar.items.dpe.settings.display_name',
    description: 'searchbar.items.dpe.settings.description',
    searchable: true,
    component: components.Settings,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Settings - ${parent(route)}`,
      ready: ['dpe_repositories', 'dpe_quotas']
    }
  },
  {
    path: '/:dataplantId/job/:id',
    name: 'DPE - Jobs Details',
    component: components.JobDetails,
    meta: {
      analytics: { category: 'details' },
      title: (route, parent) => `Job - ${parent(route)}`,
      ready: ['dpe_jobs']
    }
  },
  {
    path: '/:dataplantId/console',
    name: 'DPE - Log Console',
    meta: {
      analytics: { category: 'console' },
      title: (route, parent) => `Log - ${parent(route)}`,
      fullscreen: true,
      ready: ['dpe_jobs', 'dpe_workflows', 'dpe_actions', 'dpe_repositories']
    },
    component: components.Console,
    props: (route) => ({ full: true, id: route.query.id, executionId: route.query['execution-id'], invert: route.query.invert })
  },
  {
    path: '/:dataplantId/notebooks',
    name: 'DPE - Notebooks',
    display_name: 'searchbar.items.dpe.notebooks.display_name',
    description: 'searchbar.items.dpe.notebooks.description',
    searchable: true,
    component: components.Notebooks,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Notebooks - ${parent(route, false)}`,
      ready: ['dpe_notebooks']
    }
  },
  {
    path: '/:dataplantId/notebook',
    name: 'DPE - New Notebook',
    component: components.NotebookEditor,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Notebooks - ${parent(route, false)}`,
      ready: ['dpe_notebooks']
    }
  },
  {
    path: '/:dataplantId/notebook/:id',
    name: 'DPE - Edit Notebook',
    component: components.NotebookEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Notebooks - ${parent(route, false)}`,
      ready: ['dpe_notebooks']
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: { name: 'DPE' }
  }
]

export const basePath = 'dpe/'
export default routes
